module.exports = __webpack_public_path__ + "img/reload.fe1e2fa8.svg";